export default {"src":"/_next/static/image/public/images/flags/flag_688.a5dc3a215fd5131463edc4363f02bfe0.svg","height":16,"width":24};